module.exports = __webpack_public_path__ + "img/Mstorybg402.17a6f672.png";